export default __webpack_public_path__ + "static/media/038-hummingbird.c9478046.svg";